import firebase from 'firebase/app';
import 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyA2QFtZfV6_ZmnywMbIaXMxrr7Vwk5sszw",
  authDomain: "e-commerce-backend-20bd3.firebaseapp.com",
  projectId: "e-commerce-backend-20bd3",
  storageBucket: "e-commerce-backend-20bd3.firebasestorage.app",
  messagingSenderId: "719842148502",
  appId: "1:719842148502:web:3918afb23f3112aa2fc2b7"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const isMessagingSupported = typeof window !== 'undefined' && firebase.messaging.isSupported();
const messaging = isMessagingSupported ? firebase.messaging() : null;

export const requestForToken = async () => {
  if (!messaging || !('serviceWorker' in navigator)) return null;

  try {
    // Wait for the SW our own serviceWorkerRegistration.js already
    // registered to actually become active before handing it to
    // Firebase - calling getToken() too early fails with
    // "no active Service Worker" since the registration isn't ready yet.
    const registration = await navigator.serviceWorker.ready;

    const currentToken = await messaging.getToken({
      vapidKey: 'BEdYvTluuhQXKKKOwnv3dUzEc2rX0zm3AzkrNYe4n4pTGfVmV9TgfBSpsxE_b2LgYJ6eD7fgKFYlGxrsgU4IbI4',
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      console.log('✨ Admin FCM Token:', currentToken);
      // This token is required by the backend to push notifications to this device!
      return currentToken;
    }
    console.log('No registration token available. Request permission to generate one.');
    return null;
  } catch (err) {
    console.log('An error occurred while retrieving token. ', err);
    return null;
  }
};

export const deleteFcmToken = () => {
  if (!messaging) return Promise.resolve(false);

  return messaging
    .deleteToken()
    .then(() => true)
    .catch((err) => {
      console.log('An error occurred while deleting the token. ', err);
      return false;
    });
};

export const onMessageListener = (callback) => {
  if (!messaging) return () => {};
  return messaging.onMessage((payload) => {
    callback(payload);
  });
};

export { firebase, messaging };
